package com.macrofocus.eflux.network

import com.macrofocus.common.units.Kilovolt
import com.macrofocus.common.units.Quantity
import com.macrofocus.common.units.Voltage

public fun colorRank(voltage: Quantity<Voltage>?) : Int? {
    val green = 0
    val yellow = 1
    val orange = 2
    val red = 3
    return when {
        voltage == null -> null
        voltage > 421.Kilovolt -> red
        voltage > 418.Kilovolt -> orange
        voltage > 416.Kilovolt -> yellow
        voltage > 399.Kilovolt -> green
        voltage > 397.Kilovolt -> yellow
        voltage > 390.Kilovolt -> orange
        voltage > 360.Kilovolt -> red
        voltage > 246.Kilovolt -> red
        voltage > 243.Kilovolt -> orange
        voltage > 241.Kilovolt -> yellow
        voltage > 229.Kilovolt -> green
        voltage > 227.Kilovolt -> yellow
        voltage > 220.Kilovolt -> orange
        voltage > 210.Kilovolt -> red
        else -> null
    }
}